import * as React from 'react';
import styles from './index.less';
import { FI18n, FUtil } from '@freelog/tools-lib';
import FComponentsLib from '@freelog/components-lib';
import { Space } from 'antd';
// import FInput_MultiLine from '../FInput_MultiLine';
import FInput_PinyinSafeTextCounter_MultiLine from '@/components/FInput_PinyinSafeTextCounter_MultiLine';
import FExpandable from '@/components/FExpandable';

interface FIntroductionInputProps {
  value: string;
  title?: string;
  tip?: string;
  btnText?: string;
  className?: string;
  /** 字符数上限，默认 200 */
  lengthLimit?: number;
  /** 禁用编辑入口 */
  disabled?: boolean;

  onOK(value: string): void;

  onEditingChange?(isEditing: boolean): void;
}

function FIntroductionInput({
  value,
  title = FI18n.i18nNext.t('edit_exhibit_description'),
  tip = FI18n.i18nNext.t('listing_description_info'),
  btnText = FI18n.i18nNext.t('listing_description_btn'),
  className,
  lengthLimit = 200,
  disabled = false,
  onOK,
  onEditingChange,
}: FIntroductionInputProps) {
  const [$isEdit, set$isEdit, get$isEdit] = FUtil.Hook.useGetState<boolean>(false);
  const [$value, set$value, get$value] = FUtil.Hook.useGetState<string>(value);
  const [$valueError, set$valueError, get$valueError] = FUtil.Hook.useGetState<string>('');

  function onEdit() {
    set$isEdit(true);
    onEditingChange?.(true);
    set$value(value);
  }

  return (
    <div className={[styles.block, className].filter(Boolean).join(' ')}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <FComponentsLib.FContentText text={title} type={'highlight'} />

        <Space size={10}>
          {!$isEdit && value !== '' && (
            <FComponentsLib.FTextBtn
              style={{ fontSize: 12 }}
              disabled={disabled}
              onClick={() => {
                onEdit();
              }}
            >
              {FI18n.i18nNext.tAuto('edit')}
            </FComponentsLib.FTextBtn>
          )}
          {$isEdit && (
            <>
              <FComponentsLib.FTextBtn
                style={{ fontSize: 12 }}
                type='default'
                onClick={() => {
                  set$isEdit(false);
                  onEditingChange?.(false);
                }}
              >
                {FI18n.i18nNext.tAuto('cancel')}
              </FComponentsLib.FTextBtn>
              <FComponentsLib.FTextBtn
                style={{ fontSize: 12 }}
                onClick={() => {
                  onOK(get$value());
                  set$isEdit(false);
                  onEditingChange?.(false);
                }}
                disabled={$value.length > lengthLimit}
              >
                {FI18n.i18nNext.tAuto('save')}
              </FComponentsLib.FTextBtn>
            </>
          )}
        </Space>
      </div>

      {$isEdit && (
        <div>
          <FInput_PinyinSafeTextCounter_MultiLine
            value={$value}
            lengthLimit={lengthLimit}
            onChangeValue={(value) => {
              set$value(value);
            }}
          />

          {$valueError !== '' && (
            <>
              <div style={{ height: 5 }} />
              <div style={{ color: '#EE4040' }}>{$valueError}</div>
            </>
          )}
        </div>
      )}

      {!$isEdit && value !== '' && (
        <FExpandable dep={value} footerOutside footerAlign='end' maskTone='gray'>
          <div className={styles.aboutPanel}>
            <pre>{value}</pre>
          </div>
        </FExpandable>
      )}

      {!$isEdit && value === '' && (
        // Figma：标题与辅助文案间距 20；次要描边按钮
        <div className={styles.emptyBody}>
          <div className={styles.emptyTip}>
            {tip.split('<br />').map((text, textIndex) => {
              return (
                <FComponentsLib.FContentText text={text} key={textIndex} type={'additional2'} />
              );
            })}
          </div>
          <FComponentsLib.FRectBtn
            type='transparent'
            className={styles.outlineBtn}
            disabled={disabled}
            onClick={() => {
              onEdit();
            }}
          >
            {btnText}
          </FComponentsLib.FRectBtn>
        </div>
      )}
    </div>
  );
}

export default FIntroductionInput;
